import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { FAQS } from '../data/siteData';
import useReveal from '../hooks/useReveal';

export default function FAQ() {
  const headRef = useReveal();
  const listRef = useReveal();

  return (
    <section className="section faq-section" id="faq" aria-label="Frequently asked questions" data-testid="faq-section">
      <div className="section-inner faq-inner">
        <div className="section-head reveal" ref={headRef}>
          <span className="section-eyebrow">// PRE-FLIGHT QUESTIONS</span>
          <h2 className="section-title">
            ASKED BEFORE <span className="text-pink">TAKE-OFF</span>
          </h2>
          <p className="section-sub">Everything you need to know before we light the engines.</p>
        </div>

        <div className="reveal" ref={listRef}>
          <Accordion type="single" collapsible className="faq-accordion" data-testid="faq-accordion">
            {FAQS.map((faq, i) => (
              <AccordionItem key={faq.q} value={`faq-${i}`} className="faq-item" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="faq-trigger">{faq.q}</AccordionTrigger>
                <AccordionContent className="faq-content">{faq.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
